import "./App.css";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';

import Home from "./components/Home";
import Drawings from "./components/Drawings";
import UIUX from "./components/UIUX";
import Works3D from "./components/3DWorks";
import ITProjects from "./components/ITProjects";
import GameDev from "./components/GameDev";
import Blog from './components/Blog';
import About from './components/About';
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import CopyRights from "./components/CopyRights";
import ServerDown from "./components/ServerDown";

function App() {

  const [serverDown, setServerDown] = useState(false);

  axios.defaults.baseURL = 'https://yasiru-portfolio-backend.onrender.com'; // This is base backend server URL on Render
  // axios.defaults.baseURL = 'https://web-production-2e8e6.up.railway.app'; // This is base backend server URL on Railway
  // axios.defaults.baseURL = 'http://localhost:4000'; // Local backend url

  // use useEffect hook to check server status
  useEffect(() => {
    const checkServer = async () => {
      try {
        await axios.get("/api/project/health"); // /health for to verify that applications and services are performing correctly 
        setServerDown(false);
      } catch (error) {
        console.error("Server is down!", error.message);
        setServerDown(true);
      }
    }

    checkServer();
  }, [])

  if (serverDown) {
    return <ServerDown />
  }

  return (
    <div className="ruled-background">
      <Router>
        <div className="content">
          <NavBar />
          <div className="content-body">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/drawings" element={<Drawings />} />
              <Route path="/ui-ux" element={<UIUX />} />
              <Route path="/3d-works" element={<Works3D />} />
              <Route path="/it-projects" element={<ITProjects />} />
              <Route path="/game-dev-works" element={<GameDev />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/about-me" element={<About />} />
              <Route path="/copyrights" element={<CopyRights />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </Router>
    </div>
  );
}

export default App;